<template>
    <div class="full-width full-height dynamic-form q-pa-md">
      <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs">
        <div class="map-container">
          <div id="map" class="map-area"></div>
        </div>
          <jt-dynamic-form
            v-if="formModel"
            ref="jtDynamicForm"
            :inputs="formModel.inputs"
            :interface="formModel.nmInterface"
            :relacionamentos="formModel.relacionamentos"
            :model="collectionPoint"
            no-scroll
            form-class="jtDFModalReasonJustificationWaste"
          />
          <div class="full-width collection-point-btn-bar">
            <div v-for="(button, i) in formModel.buttons" :key="i" class="collection-point-btn collection-point-btn-first">
                <q-btn no-wrap color="info" @click="actionButton(button)" >
                <q-icon
                    v-if="button.icon"
                    :name="button.icon"
                    size="18px"
                    class="position-icon-filter"
                />
                {{ button.label }}
                </q-btn>
            </div>
          </div>
      </div>
      <q-dialog v-if="flModal" v-model="flModal">
          <q-layout class="modal-small bg-white">
            <q-header class="bg-primary">
              <q-toolbar>
                <q-toolbar-title>{{
                  $gettext("REPLICATE_DATA")
                }}</q-toolbar-title>
                <q-btn
                @click="resetCollectionPointToLastSave"
                flat
                round
                dense
                size="1.5em"
                icon="cancel"
              />
              </q-toolbar>
            </q-header>
            <q-page-container class="card-container-modal">
              <div class="modal-replicate-container">
                <span class="replicate-title">Você deseja replicar os dados de cliente?</span>
                <div class="replicate-content">
                  <button tabindex="0" @click="replicateData()" type="button" class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
                    <span class="q-focus-helper"></span>
                      <span class="q-btn__wrapper col row q-anchor--skip">
                        <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                          Replicar
                        </span>
                    </span>
                  </button>
                </div>
              </div>
            </q-page-container>
          </q-layout>
        </q-dialog>
    </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { JtCrud, JtTextInput } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'
import { readonly } from '@vue/composition-api'
import CollectionPointForm from './client-model/collection-point.form'

@Component({
  components: {
    JtTextInput
  },
  mixins: [modal],
  name: 'collectionPointRegisterForm',
  props: {
    forms: {},
    title: String,
    client: {},
    updateCollectionPoint: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showReplicateData: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    nmInterface: String,
    saveNewOnConfirm: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    clientId: Number,
    collectionPointId: Number
  }
})
class CollectionPointRegisterForm extends Vue {
  formModel = {};
  form = [];
  map = null;
  marker = null;
  collectionPoint = {};
  flModal = false;
  streetSearchSucceed;
  pickedLocation = {
    lat: null,
    lng: null,
    textLatLng: null
  };

  created () {
    this.generateForm()
    this.collectionPoint = new CollectionPointForm()
  }

  @Watch('collectionPoint.latitude')
  onCollectionPointLatitudeChanged (val) {
    this.collectionPoint.latitude = this.sanitizeCoordinate(val, -90, 90)
    const currentZoom = this.map.getZoom()
    this.setMarkerToUpdateCollectionPoint(this.collectionPoint.latitude, this.collectionPoint.longitude, currentZoom)
  }

  @Watch('collectionPoint.longitude')
  onCollectionPointLongitudeChanged (val) {
    this.collectionPoint.longitude = this.sanitizeCoordinate(val, -180, 180)
    const currentZoom = this.map.getZoom()
    this.setMarkerToUpdateCollectionPoint(this.collectionPoint.latitude, this.collectionPoint.longitude, currentZoom)
  }

  sanitizeCoordinate (value, min, max) {
    const cleaned = value
      .replace(/[a-zA-Z]/g, '')
      .replace(/,/g, '.')
      .replace(/^(-?)(.*)/, (_, dash, rest) => dash + rest.replace(/-/g, ''))
      .replace(/(\..*?)\..*/g, '$1')

    const parts = cleaned.split('.')
    let integerPart = parseInt(parts[0], 10)
    const decimalPart = parts[1] ? parts[1].slice(0, 6) : ''

    if (integerPart < min) {
      integerPart = min
    }
    if (integerPart > max) {
      integerPart = max
    }

    return decimalPart ? `${integerPart}.${decimalPart}` : `${integerPart}`
  }

  async checkAreaCodeUniqueness () {
    const areaCode = this.collectionPoint.areaCode.toString()
    const isDBUnique = await repository.resolveLogic('collectionPoint.checkAreaCodeUniqueness', { areaCode })
    return isDBUnique
  }

  async fetchCoordinates ({ number, street, city, state } = {}) {
    const zoomMap = 15
    try {
      const query = this.queryBuilder(number, street, city, state)
      const response = await axios.get('https://nominatim.openstreetmap.org/search?', {
        params: {
          q: query,
          limit: 1,
          format: 'json',
          countrycodes: 'BR' // Limita a busca ao Brasil
        }
      })
      this.moveMapToResponseCoordinates(response, zoomMap, street, city, state)
    } catch (error) {
      messageBox.error(this.$gettext('ERROR_CITY_API'))
    }
  }

  moveMapToResponseCoordinates (response, zoomMap, street, city, state) {
    if (response.data && response.data.length > 0) {
      this.streetSearchSucceed = true
      const location = response.data[0]
      const lat = parseFloat(location.lat)
      const lng = parseFloat(location.lon)
      const cityCoord = [lat, lng]

      this.pickedLocation = {
        lat,
        lng: lng,
        textLatLng: `${lat}, ${lng}`
      }

      if (!this.map) {
        this.map = L.map('map').setView(cityCoord, zoomMap)
      } else {
        this.map.setView(cityCoord, zoomMap)
      }
      this.map.setView(cityCoord, zoomMap)

      if (this.streetSearchSucceed) {
        // set lat and lng to collectionPoint
        this.collectionPoint.latitude = lat
        this.collectionPoint.longitude = lng

        // set marker on the map
        if (!this.marker) {
          this.marker = L.marker(cityCoord).addTo(this.map)
        } else {
          this.marker.setLatLng(cityCoord)
        }
      }
    } else {
      // if the street was not found, try to search only with the city and state
      this.streetSearchSucceed = false
      messageBox.warn(this.$gettextInterpolate(this.$gettext('STREET_NOT_FOUND'), { street: street }))
      setTimeout(() => {
        messageBox.warn(this.$gettext('MAP_REPOSITIONING_MESSAGE'))
      }, 500)
      this.searchForCity(city, state)
    }
  }

  queryBuilder (number, street, city, state) {
    const queryParts = []
    if (number) queryParts.push(number)
    if (street) queryParts.push(street)
    if (city) queryParts.push(city)
    if (state) queryParts.push(state)

    const query = queryParts.join(',')
    return query
  }

  searchForCity (city, state) {
    if (!this.streetSearchSucceed) {
      this.fetchCoordinates({ city: city, state: state })
    }
  }

  mounted () {
    this.initializeMap()
    if (this.showReplicateData) {
      this.openReplicateQuestionIfNotEditing()
    }
  }

  isEditingCollectionPoint () {
    const hasUpdateContract = !!(this.updateCollectionPoint)
    const isNotEmptyUpdateContract = Object.keys(this.updateCollectionPoint).length > 0
    return hasUpdateContract && isNotEmptyUpdateContract
  }

  openReplicateQuestionIfNotEditing () {
    if (!this.isEditingCollectionPoint()) {
      this.flModal = true
    } else {
      this.replicateUpdateToCollectionPoint()

      this.setMarkerToUpdateCollectionPoint(this.updateCollectionPoint.latitude, this.updateCollectionPoint.longitude)
    }
  }

  replicateUpdateToCollectionPoint () {
    this.collectionPoint.addressName = this.updateCollectionPoint.addressName
    this.collectionPoint.name = this.updateCollectionPoint.name
    this.collectionPoint.number = this.updateCollectionPoint.addressNumber
    this.collectionPoint.detail = this.updateCollectionPoint.addressDetail
    this.collectionPoint.addressNeighborhoodName = this.updateCollectionPoint.addressNeighborhood
    this.collectionPoint.addressZipCode = this.updateCollectionPoint.addressZipCode
    this.collectionPoint.addressNeighborhoodCityName = this.updateCollectionPoint.municipalRegistration
    this.collectionPoint.addressNeighborhoodCityStateName = this.updateCollectionPoint.stateRegistration
    this.collectionPoint.city = this.updateCollectionPoint.municipalRegistration
    this.collectionPoint.state = this.updateCollectionPoint.stateRegistration
    this.collectionPoint.latitude = this.updateCollectionPoint.latitude
    this.collectionPoint.longitude = this.updateCollectionPoint.longitude
    this.collectionPoint.areaCode = this.updateCollectionPoint.areaCode
    this.collectionPoint.addressId = this.updateCollectionPoint.addressId
  }

  setMarkerToUpdateCollectionPoint (latitude, longitude, zoomMap) {
    zoomMap = zoomMap || 15
    const cityCoord = [latitude, longitude]
    if (!this.map) {
      this.map = L.map('map').setView(cityCoord, zoomMap)
    } else {
      this.map.setView(cityCoord, zoomMap)
    }
    this.map.setView(cityCoord, zoomMap)

    if (!this.marker) {
      this.marker = L.marker(cityCoord).addTo(this.map)
    } else {
      this.marker.setLatLng(cityCoord)
    }
  }

  initializeMap () {
    const brazilCoord = [-14.2350, -51.9253]
    const zoomMap = 4
    this.map = L.map('map').setView(brazilCoord, zoomMap)

    const DefaultIcon = L.icon({
      iconUrl: markerIcon,
      shadowUrl: markerShadow,
      iconSize: [25, 41], // size of the icon
      iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
      popupAnchor: [1, -34], // point from which the popup should open relative to the iconAnchor
      shadowSize: [41, 41] // size of the shadow
    })

    L.Marker.prototype.options.icon = DefaultIcon

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map)

    this.map.on('click', this.onMapClick)
  }

  replicateData () {
    this.fetchCoordinates(this.buildAdressRequestObject(this.client))
    this.collectionPoint.addressName = this.client.addressName
    this.collectionPoint.number = this.client.number
    this.collectionPoint.detail = this.client.detail
    this.collectionPoint.addressNeighborhoodName = this.client.neighborhood
    this.collectionPoint.addressZipCode = this.client.zipCode
    this.collectionPoint.addressNeighborhoodCityName = this.client.cityText
    this.collectionPoint.addressNeighborhoodCityStateName = this.client.stateText
    this.flModal = false
  }

  buildAdressRequestObject (sourceObj) {
    return {
      number: sourceObj.number,
      street: sourceObj.addressName,
      city: sourceObj.cityText,
      state: sourceObj.stateText
    }
  }

  onMapClick (e) {
    const { lat, lng } = e.latlng
    // If a marker already exists, move it to the new location
    if (this.marker) {
      this.marker.setLatLng(e.latlng)
    } else {
      // If no marker exists, create a new one
      this.marker = L.marker([lat, lng]).addTo(this.map)
    }

    const textLat = this.getTextLat(lat)
    const textLng = this.getTextLat(lat)
    const textLatLng = this.getTextLatLng(textLat, textLng)

    this.collectionPoint.latitude = textLat
    this.collectionPoint.longitude = textLng

    // Update the picked location
    this.pickedLocation = { lat, lng, textLatLng }

    messageBox.info(this.$gettext('MAP_LOCATION_SELECTED'))
  }

  getTextLng (lng) {
    const textLngArr = lng.toString().split('.')
    return textLngArr[0] + '.' + textLngArr[1].substring(0, 8)
  }

  getTextLat (lat) {
    const textLatArr = lat.toString().split('.')
    return textLatArr[0] + '.' + textLatArr[1].substring(0, 8)
  }

  getTextLatLng (textLat, textLng) {
    return textLat + ',' + textLng
  }

  async fetchAddress (lat, lng) {
    try {
      const response = await axios.get('https://nominatim.openstreetmap.org/reverse?lat=<value>&lon=<value>&<params>', {
        params: {
          lat: lat,
          lon: lng,
          format: 'json'
        }
      })
      if (response.data && response.data.address) {
        const address = response.data.address
        this.collectionPoint.addressName = address.road
        this.collectionPoint.addressNeighborhoodName = address.suburb
        this.collectionPoint.addressNeighborhoodCityName = address.city || address.city_district || address.town
        this.collectionPoint.addressNeighborhoodCityStateName = address.state
      } else {
        messageBox.error(this.$gettext('COORDINATES_NOT_FOUND'))
      }
    } catch (error) {
      messageBox.error(this.$gettext('ERROR_COORDINATES_API'))
    }
  }

  checkNotEmptyLatLng () {
    return this.collectionPoint.latitude || this.collectionPoint.longitude
  }

  async generateForm () {
    this.form = await repository.resolve(this.nmInterface, this.params)
    this.formModel = this.form[0]
  }

  get elInputs () {
    return this.formModel.inputs
  }

  get inputs () {
    return this.form[0].inputs
  }

  async actionButton (button, params, page) {
    this.collectionPoint.client = this.clientId
    this.collectionPoint.id = this.collectionPointId
    if (button.name === 'btGravar') {
      if (!this.$refs.jtDynamicForm.isValidForm()) {
        return
      }
      if (!(await this.checkAreaCodeUniqueness())) {
        document.getElementById('areaCode').focus()
        messageBox.error(this.$gettext('AREA_CODE_ALREADY_EXISTS'))
        return
      }
      if (!this.checkNotEmptyLatLng()) {
        messageBox.error(this.$gettext('LAT_LNG_NOT_FOUND'))
        return
      }
      if (!this.saveNewOnConfirm) {
        if (this.isEditingCollectionPoint()) {
          this.$emit('savingUpdateCollectionPoint', this.collectionPoint, this.updateCollectionPoint.index)
        } else {
          this.$emit('confirm', this.collectionPoint)
        }
      } else {
        await repository.resolveLogic(this.nmInterface, this.collectionPoint)
        messageBox.success('Ponto de coleta salvo com sucesso')
        this.$emit('confirmarSalvar')
      }
    }
    if (button.name === 'btAlterar') {
      if (!this.$refs.jtDynamicForm.isValidForm()) {
        return
      }
      await repository.resolveLogic(this.nmInterface, this.collectionPoint)
      messageBox.success('Ponto de coleta salvo com sucesso')
      this.$emit('confirmarSalvar')
    }
    if (button.name === 'mapRepositioning') {
      this.streetSearchSucceed = true
      this.fetchCoordinates({
        number: this.collectionPoint.number,
        street: this.collectionPoint.addressName,
        city: this.collectionPoint.addressNeighborhoodCityName,
        state: this.collectionPoint.addressNeighborhoodCityStateName
      })
    }
  }

  prepareInputs (inputs) {
    inputs.forEach(input => {
      if (this.flComposicaoAlteracao && this.flMainCrudInChange && this.nonChangeableFields.includes(input.model)) {
        input.readonly = true
      }
    })

    return inputs
  }

  resetCollectionPointToLastSave () {
    this.closeDialog()
  }

  closeDialog () {
    this.flModal = false
  }
}
export default CollectionPointRegisterForm
</script>
<style lang="stylus" scoped>
.map-area {
  height: 400px;
  width: 100%;
}
.map-container {
  width: 100%;
}
.modal-replicate-container {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 120px;
}
.replicate-title {
  font-size: 14pt;
}
.replicate-content {
  text-align: center;
}
.modal-small {
  height: 250px !important;
  max-height: 250px !important;
  min-height: 250px !important;
  width: 500px !important;
  max-width: 500px !important;
  min-width: 500px !important;
}
.collection-point-btn-first:first-child {
  text-align: right;
}

.collection-point-btn {
  width: full;
  flex: 1
}

.collection-point-btn-bar {
  display: flex;
  width: 100%;
  justify-content:
  center; gap: 1.2rem
}

</style>
